import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const AnimationArrow = ({ classNames, onClick }) => (
  <OverlayTrigger
    overlay={<Tooltip id="tooltip-split">Show or hide this area.</Tooltip>}
    placement="top"
  >
    <div className={classNames} onClick={onClick}>
      <div className="arrow-sliding">
        <div className="arrow"></div>
      </div>
      <div className="arrow-sliding delay1">
        <div className="arrow"></div>
      </div>
      <div className="arrow-sliding delay2">
        <div className="arrow"></div>
      </div>
    </div>
  </OverlayTrigger>
);



// WEBPACK FOOTER //
// src/components/AnimationArrow.jsx